import {
	MONTH_FIELDS,
	months,
	QUARTER_MONTHS,
} from 'views/Components/Forecast/utils/monhts';

import FIKA from 'assets/images/icons/fika-icon.svg';
import TRENT from 'assets/images/icons/trent-icon.svg';
import GENERICO from 'assets/images/icons/generico-icon.svg';
import SINASIGNAR from 'assets/images/icons/sinAsignar-icon.svg';
import FEMMTO from 'assets/images/icons/femmto-icon.svg';
import MeliIcon from 'assets/images/icons/meli-icon.svg';
import VtexIcon from 'assets/images/icons/vtex-icon.svg';
import AmazonIcon from 'assets/images/icons/amazon-icon.svg';
import B2bIcon from 'assets/images/icons/b2b-icon.svg';

export const generateMonthColumnVisibilityState = (
	month,
	value,
	fieldVisibility = INITIAL_COLUMNS_STATE
) => {
	const result = {};
	for (const field of MONTH_FIELDS) {
		result[`${month}-${field}`] = value && fieldVisibility[field];
	}
	return result;
};

export const changeSpecificFieldVisibilityState = (
	currentColumns,
	field,
	value
) => {
	const newState = { ...currentColumns, [field]: value };

	return newState;
};

export const generateMonthsSingleColumnVisibilityState = (
	quarter,
	field,
	value
) => {
	const result = {};
	const monthsToProcess = QUARTER_MONTHS[quarter];

	for (const month of monthsToProcess) {
		const key = `${month}-${field}`;

		result[key] = value;
	}

	return result;
};

export const changeMonthsSpecificColumnVisibilityState = (
	currentColumns,
	quarter,
	field,
	value
) => {
	return Object.assign(
		{},
		currentColumns,
		generateMonthsSingleColumnVisibilityState(quarter, field, value)
	);
};

const quarterVisibilityCache = new Map();

export const generateQuarterColumnsVisibilityState = (
	quarter,
	fieldVisibility = INITIAL_COLUMNS_STATE
) => {
	const cacheKey = `${quarter}-${JSON.stringify(fieldVisibility)}`;

	if (quarterVisibilityCache.has(cacheKey)) {
		return quarterVisibilityCache.get(cacheKey);
	}

	let result;
	if (quarter === 'all') {
		result = generateInitialColumnsVisibilityState(fieldVisibility);
	} else {
		result = {
			thumbnail: fieldVisibility['thumbnail'],
			sku: fieldVisibility['sku'],
			category_owner: fieldVisibility['category_owner'],
		};

		const visibleMonths = QUARTER_MONTHS[quarter];
		const hiddenMonths = months.filter((m) => !visibleMonths.includes(m));

		// Process visible months
		visibleMonths.forEach((month) => {
			Object.assign(
				result,
				generateMonthColumnVisibilityState(month, true, fieldVisibility)
			);
		});

		// Process hidden months
		hiddenMonths.forEach((month) => {
			Object.assign(
				result,
				generateMonthColumnVisibilityState(month, false, fieldVisibility)
			);
		});
	}

	quarterVisibilityCache.set(cacheKey, result);
	return result;
};

export const generateInitialColumnsVisibilityState = (
	fieldVisibility = INITIAL_COLUMNS_STATE
) => {
	const result = {
		thumbnail: fieldVisibility['thumbnail'],
		sku: fieldVisibility['sku'],
		category_owner: fieldVisibility['category_owner'],
	};

	// Apply month-field combinations
	months.forEach((month) => {
		Object.assign(
			result,
			generateMonthColumnVisibilityState(month, true, fieldVisibility)
		);
	});

	return result;
};

export const COLUMNS_TO_FILTER = [
	{ data: 'thumbnail', label: 'Foto' },
	{ data: 'sku', label: 'SKU' },
	{ data: 'brand', label: 'Brand' },
	{ data: 'category_owner', label: 'Category Owner' },
	{
		data: 'pvp',
		label: 'PVP',
	},
	{
		data: 'tsu',
		label: 'TSU',
	},
	{
		data: 'mg',
		label: 'MG %',
	},
	{
		data: 'gmv_local',
		label: 'GMV (Pesos)',
	},
	{
		data: 'gmv_usd',
		label: 'GMV (USD)',
	},
];

export const SINGLE_FIELD_COLUMNS = [
	'thumbnail',
	'sku',
	'brand',
	'category_owner',
];

export const INITIAL_COLUMNS_STATE = {
	thumbnail: true,
	sku: true,
	category_owner: true,
	brand: true,
	label: true,
	pvp: true,
	tsu: true,
	mg: true,
	gmv_local: true,
	gmv_usd: true,
	profit: true,
	cbm: true,
};

export function removeDuplicates(array) {
	const uniqueArray = [];

	for (const item of array) {
		if (!uniqueArray.some((uniqueItem) => uniqueItem.title === item.title)) {
			uniqueArray.push(item);
		}
	}

	return uniqueArray;
}

export const brandIcons = {
	FIKA: FIKA,
	TRENT: TRENT,
	GENERICO: GENERICO,
	'SIN ASIGNAR': SINASIGNAR,
	FEMMTO: FEMMTO,
};

export const MarketplaceIcons = {
	MELI: MeliIcon,
	VTEX: VtexIcon,
	AMZN: AmazonIcon,
	OFF: B2bIcon,
};
